import { useMutation } from "@tanstack/react-query";
import api from "../../../api";
import { toast } from "react-toastify";
import { toastStyles } from "../../../styles/styles";
import { PAGE_CONFIG } from "../config";

export const useCreateConstitution = (queryClient, theme, onSuccessCallback) => {
    const { mutate: createConstitution, status: createStatus, isPending: isCreating } = useMutation({
        mutationFn: (data) => api.constitutions.createConstitution(data),
        onSuccess: (data) => {
            toast.success(data?.message || 'Constitution created successfully', { ...toastStyles, theme: theme });
            queryClient.invalidateQueries([PAGE_CONFIG.GET_QUERY_KEY]);
            onSuccessCallback && onSuccessCallback();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || 'Constitution creation failed', { ...toastStyles, theme: theme });
        }
    });

    return { createConstitution, isCreating, createStatus };
};